import React, { useEffect, useState } from 'react';
import Config from '../../config/Config';
import { connect } from 'react-redux';
import { appendScript } from '../../utils/appendScript';
import { removeScript } from '../../utils/removeScript';
import Card from 'react-bootstrap/Card';
import Report from './report';

const Score = ({
	oLevel,
	rLevel,
	wLevel,
	lLevel,
	sLevel,
	isRetail,
	showScore,
	containsEmail
}) => {
	useEffect(() => {
		if (!!showScore) {
			if (!!parseInt(oLevel, 10)) {
				appendScript('easypiechart');
				appendScript('easypiechart-data');
			}
			return () => {
				removeScript('easypiechart');
				removeScript('easypiechart-data');
			};
		}
	}, [oLevel, showScore]);
	const [viewReport, setViewReport] = useState(false);

	return !!showScore && (containsEmail.indexOf('naanmudhalvan') === -1) && isRetail ? (
		<div>
			<div className="row">
				<div className="col-lg-12 col-xs-12 col-md-12">
					<Card>
						<Card.Body>
							<div className=" easypiechart-panel row  DesktopProgressCourse">
								<div
									className="col-lg-4 col-md-4 col-sm-12 col-sx-12 border-right"
									style={{ textAlign: 'center' }}
								>
									<div
										className="easypiechart"
										id="easypiechart-green"
										data-percent={parseInt(oLevel, 10) || '--'}
									>
										<span className="percent span1">
											{oLevel || '--'}
											<span className="span3">12</span>
										</span>
									</div>
									<strong>STEP Score</strong>
								</div>

								<div className=" col-lg-7 col-md-7 col-sm-12 col-12">
									<h5 className="coursetitle">
										Based on your last test your score level is
									</h5>
									<div className="row">
										<div className="col-lg-3 col-md-6 col-sm-6">
											<div
												className="easypiechart-small"
												id="easypiechart-blue1"
												data-percent={rLevel || '--'}
											>
												<span className="percent">
													<img src={Config.ASSETSPATH + 'img/Reading.png'} alt="Reading" />
													{rLevel || '--'}
													<span>Reading</span>
												</span>{' '}
											</div>
										</div>
										<div className="col-lg-3 col-md-6 col-sm-6">
											<div
												className="easypiechart-small"
												id="easypiechart-blue2"
												data-percent={wLevel || '--'}
											>
												<span className="percent">
													<img src={Config.ASSETSPATH + 'img/Writing.png'} alt="Writing" />
													{wLevel || '--'}
													<span>Writing</span>
												</span>
											</div>
										</div>
										<div className="col-lg-3 col-md-6 col-sm-6">
											<div
												className="easypiechart-small"
												id="easypiechart-blue3"
												data-percent={lLevel || '--'}
											>
												<span className="percent">
													<img
														src={Config.ASSETSPATH + 'img/Listening.png'}
														alt="Listening"
													/>
													{lLevel || '--'}
													<span>Listening</span>
												</span>
											</div>
										</div>
										<div className="col-lg-3 col-md-6 col-sm-6">
											<div
												className="easypiechart-small"
												id="easypiechart-blue4"
												data-percent={sLevel || '--'}
											>
												<span className="percent">
													<img src={Config.ASSETSPATH + 'img/Speaking.png'} alt="Speaking" />
													{sLevel || '--'}
													<span>Speaking</span>
												</span>
											</div>
										</div>
									</div>
									{!!oLevel && oLevel !== '--' && (
										<span
											className="viewmore"
											id="reportCard"
											onClick={() => {
												setViewReport((x) => !x);
											}}
										>
											{!viewReport ? (
												<>
													View more <i className="fa fa-chevron-down"></i>
												</>
											) : (
												<>
													View less <i className="fa fa-chevron-up"></i>
												</>
											)}
										</span>
									)}
								</div>
							</div>

							<div className="  easypiechart-panel row  MobileProgressCourse">
								<div className="row">
									<div className="col-12">
										<div className="OverAllScore">
											{oLevel || '--'}
											<div className="OverAllScoreTotal">12</div>
										</div>
									</div>
								</div>
								<div className="col-12  ">
									<div className="row ">
										<div className="col-6">
											<div className="SkillsScore">
												{rLevel || '--'}
												<span>Reading</span>
											</div>
										</div>
										<div className="col-6 ScoreBorderLeft">
											<div className="SkillsScore">
												{wLevel || '--'}
												<span>Writing</span>
											</div>
										</div>
									</div>
									<div className="row SkillsScoreBorder">
										<div className="col-6">
											<div className="SkillsScore ">
												{lLevel || '--'}
												<span>Listening</span>
											</div>
										</div>
										<div className="col-6 ScoreBorderLeft">
											<div className="SkillsScore ">
												{sLevel || '--'}
												<span>Speaking</span>
											</div>
										</div>
									</div>
								</div>
								<div
									className="row viewmore"
									id="reportCard"
									onClick={() => {
										setViewReport((x) => !x);
									}}
								>
									{!viewReport ? (
										<>
											View more <i className="fa fa-chevron-down"></i>
										</>
									) : (
										<>
											View less <i className="fa fa-chevron-up"></i>
										</>
									)}
								</div>
							</div>
						</Card.Body>
					</Card>
				</div>
			</div>
			{viewReport && <Report />}
		</div>
	) : null;
};

const mapStateToProps = (state) => {
	const { userEmail, loginId } = state.rootReducer.loginDetails;
	const containsEmail = userEmail?.indexOf("@") !== -1 ? userEmail : loginId?.indexOf("@") !== -1 ? loginId : ''

	const {
		oLevel,
		rLevel,
		wLevel,
		lLevel,
		sLevel,
		showScore,
	} = state.rootReducer.myStepDetails.score;
	return {
		oLevel,
		rLevel,
		wLevel,
		lLevel,
		sLevel,
		showScore,
		isRetail: state.rootReducer.loginDetails.isRetail,
		containsEmail
	};
};

export default connect(mapStateToProps)(Score);
